import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import appManagementReducer from './reducers';

type DetailsPageParams = {
  groupId: string;
};

const IndexPage = () => import(/* webpackChunkName: "manual-web-testing" */ './components/IndexPage');
const DetailsPage = () => import(/* webpackChunkName: "manual-web-testing" */ './components/DetailsPage');

const AppManagementRoutes = () => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        load={DetailsPage}
        path="/app-management/groups/:groupId"
      />
      <BundleRoute
        load={IndexPage}
        path="/app-management"
      />
      <Redirect to="/app-management" />
    </Switch>
  </LoginRequiredContainer>
);

export default dynamic(
  'apps.appManagement', attachReducer(appManagementReducer),
)(AppManagementRoutes);

export {
  DetailsPageParams,
};
